import { Box, BoxProps, MenuItem, Select, SelectChangeEvent, SxProps } from "@mui/material"
import dayjs from "dayjs"
import { toJS } from "mobx"
import { observer } from "mobx-react"
import CalendarIcon from "@/assets/images/CounterCards/CalendarIcon.svg"
import Image from "next/image"
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked"
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked"
import styles from "./CounterCard.module.css"
import { calculateToFromFilter } from "../InfiniteTable/InfiniteTableExt"
import { ModuleName, TAPIPayload } from "@/utils/store/AppStore.types"
import AppStore from "@/utils/store/AppStore"

var customParseFormat = require("dayjs/plugin/customParseFormat")
var utc = require("dayjs/plugin/utc")

dayjs.extend(customParseFormat)
dayjs.extend(utc)

type TFilter = {
  moduleName: ModuleName
  onChangeRangeFilter: Function
  boxProps?: BoxProps
}

const SelectSX: SxProps = {
  "&.MuiOutlinedInput-root .MuiSelect-select": {
    padding: "0 12px",
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  "&:hover.MuiOutlinedInput-root fieldset": {
    borderWidth: 0,
  },
}

const SelectDD: SxProps = {
  "& .MuiPaper-root": {
    borderRadius: "4px",
    background: "#1D2319",
    boxShadow: "6px 9px 12px 0px rgba(0, 0, 0, 0.30), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)",
    marginTop: "10px",
  },
}

const RangeList = [
  {
    label: "All Time",
    value: "All Time",
  },
  {
    label: "Today",
    value: "Today",
  },
  {
    label: "Yesterday",
    value: "Yesterday",
  },
  {
    label: "Tomorrow",
    value: "Tomorrow",
  },
  {
    label: "This Week",
    value: "This Week",
  },
  {
    label: "Past 15 days",
    value: "Past 15 days",
  },
]

const CounterCardFilter = ({ moduleName, onChangeRangeFilter, boxProps }: TFilter) => {
  const filter = AppStore.counterCardFilter[moduleName]

  const onChangeCardFilter = (event: SelectChangeEvent) => {
    const value = event.target.value as string
    const filterRange: TAPIPayload = calculateToFromFilter(value)
    const prev = toJS(AppStore.counterCardFilter)
    // console.info("Module :", moduleName, value)
    AppStore.setCounterCardFilter({
      ...prev,
      [moduleName]: value,
    })

    // console.info("Final From To:", dayjs(filterRange.from).format("DD/MM/YYYY hh:mm A"), dayjs(filterRange.to).format("DD/MM/YYYY hh:mm A"))
    if (typeof onChangeRangeFilter === "function") onChangeRangeFilter(filterRange)
  }

  return (
    <Box className={styles.CardFilterRoot} {...boxProps}>
      <Select
        labelId="select-counter-card-filter-label"
        id="select-counter-card-filter"
        value={filter ?? "All Time"}
        onChange={onChangeCardFilter}
        sx={SelectSX}
        className={styles.List}
        renderValue={(value) => {
          return (
            <Box className={styles.RenderLabel}>
              <Image src={CalendarIcon} alt={"Cal"} width={24} height={24} />
              <Box>{value}</Box>
            </Box>
          )
        }}
        MenuProps={{
          sx: SelectDD,
        }}
      >
        {RangeList.map((val) => (
          <MenuItem className={styles.ListItem} value={val.value} key={val.value}>
            {filter === val.value ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}
            {val.label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  )
}

export default observer(CounterCardFilter)
